<template functional>
<div class="footer-outer-cont">
  <div class="footer-top">
    <div class="footer-inner">
      <div class="ft-col">
        <a class="ft-tel" href="tel:2123350233">+1 (212) 335-0233</a>
      </div>
      <div class="ft-col">
        <p>Monday - Friday<br>10:00 AM - 05:00 PM (EDT)</p>
        <p>267 5th Avenue<br>New York, NY 10016</p>
      </div>
      <div class="ft-col" v-if="false">
       <div class="al-button">Upgrade My Plan</div>
      </div>
    </div>
  </div>
  <div class="footer-bottom">
    <div class="footer-inner">
    <div class="fbtm-top">
      <ul class="fbtm-list">
        <a href="https://authorizelocal.com/terms-conditions/"><li>Terms & Conditions</li></a>
        <a href="https://authorizelocal.com/privacy-policy/"><li>Privacy Policy</li></a>
        <a href="https://authorizelocal.com/copyright-policy/"><li>Copyright Policy</li></a>
      </ul>
    </div>
    COPYRIGHT © {{year}} AUTHORIZE LOCAL LLC</div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  },
  data () {
    return {
      year: new Date().getFullYear().toString()
    }
  }
}
</script>
<style lang="scss">
.footer-outer-cont{
  width:100vw;
  max-width:100vw;
  z-index: 99;
}
.footer-top{
  .footer-inner{
    width:1200px;
    max-width: 1200px;
    display:flex;
    justify-content: center;
    align-items: center;
  }
  .ft-col{
    .al-button{
      width:max-content;
    }
    .ft-tel{
      &:hover{
        text-decoration: underline;
      }
      font-size:18px;
    }
    width:33.33%;
    display:flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  display:flex;
  justify-content: center;
  background-color:#003451;
  color:#fff;
  text-align:center;
  padding:30px 0px;
}
.footer-bottom{
  .footer-inner{
    width:50%;
  }
  display:flex;
  align-items: center;
  justify-content: center;
  background-color:#002438;
  font-size:12px;
  color:#fff;
  text-align:center;
  padding:30px 0px;
  font-weight: 400 !important;
}
.fbtm-top{
  margin-bottom:15px;
  display:flex;
  justify-content: center;
}
.fbtm-list{
  display:flex;
  justify-content: center;
  width:80%;
  li{
    font-size:10px;
  }
  a {
    margin-right:15px;
    &:last-child{
      margin-right:0;
    }
    &:hover{
      text-decoration: underline;
    }
  }
}
@media (max-width:768px){
.footer-top{
  .footer-inner{
    width:100%;
    flex-direction: column;
    padding:0 20px;
  }
  .ft-col{
    .al-button{
      width:max-content;
    }
    .ft-tel{
      font-size:19px;
      font-weight: 500;
      margin-bottom:20px;
    }
    p{
      font-size:15px;
      margin-bottom:20px;
    }
    width:100%;
    font-weight: 300;
  }
  padding-bottom:0;
}
.footer-bottom{
  display:block;
  padding:15px 10px 20px 10px;
  .footer-inner{
    width:auto;
    margin:0 auto;
    font-weight: 300;
    font-size:13px;
  }
  .fbtm-top{
    display:block;
    margin:0;
    font-weight: 200;
    .fbtm-list{
      margin:0 auto;
      width:100%;
      display:block;
      a {
        margin:0;
        &:first-child{
          position:relative;
          margin-right:15px;
        &:after{
          content:' | ';
          display:block;
          position:absolute;
          top:0;
          right:-10px;
        }
      }
      }
      li{
        display:inline-block;
         text-transform: uppercase;
         font-size:11px;
         width:max-content;
      }
    }
  }
}
}
</style>
